import { PINK, VARIANT, type VariantId } from "../../lib/tokens";
import { useVariant } from "../../hooks/useVariant";
import { LEGAL_URLS } from "../../lib/platform-urls";

// Session A: Impressum/Datenschutz/AGB verlinken auf die kanonischen
// Plattform-Routen. "Über uns" bleibt bewusst ohne Ziel (separates Thema).
const FOOTER_LINKS: ReadonlyArray<{ label: string; href?: string }> = [
  { label: "Impressum", href: LEGAL_URLS.imprint },
  { label: "Datenschutz", href: LEGAL_URLS.privacy },
  { label: "AGB", href: LEGAL_URLS.terms },
  { label: "Über uns" },
];

export function Footer() {
  const { variant, setVariant } = useVariant();
  const v = VARIANT[variant];

  return (
    <footer
      style={{
        borderTop: `1px solid ${v.border}`,
        background: v.surface,
        padding: "24px 32px",
        display: "flex",
        alignItems: "center",
        gap: 20,
        flexWrap: "wrap",
        fontSize: 13,
        color: v.muted,
      }}
    >
      <span>© 2026 Scrollytelling GmbH</span>
      <span style={{ opacity: 0.5 }}>·</span>
      {FOOTER_LINKS.map((l) =>
        l.href ? (
          <a
            key={l.label}
            href={l.href}
            style={{ color: v.muted, textDecoration: "none" }}
          >
            {l.label}
          </a>
        ) : (
          <span key={l.label} style={{ color: v.muted, cursor: "pointer" }}>
            {l.label}
          </span>
        ),
      )}

      <div style={{ flex: 1 }} />

      <VariantToggle variant={variant} onChange={setVariant} />
    </footer>
  );
}

function VariantToggle({
  variant,
  onChange,
}: {
  variant: VariantId;
  onChange: (v: VariantId) => void;
}) {
  const v = VARIANT[variant];
  const pill = (id: VariantId, label: string) => {
    const active = variant === id;
    return (
      <button
        key={id}
        onClick={() => onChange(id)}
        style={{
          border: "none",
          background: active ? (variant === "immersive" ? "#fff" : "#111") : "transparent",
          color: active ? (variant === "immersive" ? "#111" : "#fff") : v.text,
          fontSize: 12,
          fontWeight: 600,
          padding: "6px 14px",
          borderRadius: 999,
          cursor: "pointer",
          fontFamily: "inherit",
          transition: "background 120ms, color 120ms",
        }}
        aria-pressed={active}
      >
        {label}
      </button>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        gap: 4,
        padding: 4,
        background: v.searchBg,
        borderRadius: 999,
        border: `1px solid ${v.border}`,
      }}
      role="group"
      aria-label="Darstellungs-Variante"
    >
      <span
        style={{
          fontSize: 11,
          color: v.muted,
          padding: "6px 10px 6px 12px",
          fontWeight: 500,
          letterSpacing: 0.3,
          textTransform: "uppercase",
        }}
      >
        Stil
      </span>
      {pill("editorial", "Editorial")}
      {pill("immersive", "Immersive")}
      <span
        style={{
          width: 4,
          height: 4,
          borderRadius: "50%",
          background: PINK,
          alignSelf: "center",
          marginLeft: 4,
          marginRight: 4,
          opacity: 0.7,
        }}
        aria-hidden="true"
      />
    </div>
  );
}
